import request from '@/Utils/request.js';
//发送验证码
export function SendSMSCode (params) {
    return request({
      url: '/api/Public/SendSMSCode',
      method: 'get',
      params: params
    });
}
//判断电话号码是否存在
export function UserExists (params) {
  return request({
    url: '/api/User/UserExists',
    method: 'get',
    params: params
  });
}


//上传单个图片文件
export function ImgUpload (data,params) {
  return request({
    url: '/api/File/ImgUpload',
    method: 'post',
    data: data,
    params:params,
    headers: {'Content-Type': 'multipart/form-data'}
  });
}

//获取证件类型列表
export function GetCertTypeList (params) {
  return request({
    url: '/api/Public/GetCertTypeList',
    method: 'get',
    params: params
  });
}
//获取阿里云OSS上传参数
export function GetSTSToken () { 
  return request({
    url: '/api/File/GetSTSToken',
    method:"post",
  })
}

//添加PV记录
export function AddPV (data) { 
  return request({
    url: '/api/Public/AddPV',
    method: "post",
    data: data
  });
}

//获取频道
export function GetChannelsList (params) { 
  return request({
    url: '/api/Public/GetChannelsList',
    method: "get",
    params: params
  });
}
//获取文章列表
export function GetNewsList (params) { 
  return request({
    url: '/api/Public/GetNewsList',
    method: "get",
    params: params
  });
}
//获取文章详情
export function GetNewsInfo (params) { 
  return request({
    url: '/api/Public/GetNewsInfo',
    method: "get",
    params: params
  });
}

//上传Blob图片文件
export function WebMUpload (data,params) {
  return request({
    url: '/api/File/FileUploadToMP3',
    method: 'post',
    data: data,
    params:params,
    headers: {'Content-Type': 'multipart/form-data'}
  });
}